import Vue from "vue";
import Vuex from "vuex";
import snackbar from "./modules/snackbar";
import tenants from "./modules/tenants";
import user from "./modules/user";
import customers from "./modules/customers";
import plants from "./modules/plants";
import plantSpecies from "./modules/plantSpecies";
import colors from "./modules/colors";
import tags from "./modules/tags";
import environments from "./modules/environments";
import potSizes from "./modules/potSizes";
import plantGrowthTemplates from "./modules/plantGrowthTemplates";
import products from "./modules/products";
import productCategories from "./modules/productCategories";
import productItems from "./modules/productItems";
import growthTasks from "./modules/growthTasks";
import inventoryChangeReasonTag from "./modules/inventoryChangeReasonTags";
import inventory from "./modules/inventory";
import sales from "./modules/sales";
import suppliers from "./modules/suppliers";
import greenhouses from "./modules/greenhouses";
import greenhouseDepartments from "./modules/greenhouseDepartments";
import greenhouseDepartmentSections from "./modules/greenhouseDepartmentSections";
import plannedTasks from "./modules/plannedTasks";
// import mapGetters from "vuex"

Vue.use(Vuex);

// const getters = {
//   ...mapGetters("user", "isLoggedIn")
// }

export default new Vuex.Store({
    // getters: getters,
    modules: {
        snackbar,
        user,
        tenants,

        // plants
        plants,
        plantSpecies,
        colors,
        tags,
        environments,
        potSizes,
        plantGrowthTemplates,

        // products
        products,
        productCategories,
        productItems,

        // growth tasks
        growthTasks,

        // inventory
        inventoryChangeReasonTag,
        inventory,

        // sales
        sales,

        // tenants
        customers,
        suppliers,
        greenhouses,
        greenhouseDepartments,
        greenhouseDepartmentSections,

        // planner
        plannedTasks
    }
});
